import Vue from 'vue';
import Router from 'vue-router';
import NHHD20200120 from '@/views/20200120NHHD';
import LHYZ20200109 from '@/views/20200109LHYZ';
import LHYZPre20200109 from '@/views/20200109LHYZPre';
import ZBB2020 from '@/views/20200101ZBB';
import JTYM20200118 from '@/views/20200118JTYM';
import CQLH20200106 from '@/views/20200106CQLHReport';
import GJKYSD20200108 from '@/views/20200108GJKYSD';
import MSMZWriting20190121 from '@/views/20190121MSMZWriting';
import TCTYSYYDJ20200203 from '@/views//20200203TCTYSYYDJ';
import SARI20200128 from '@/views/20200128SARI';
import SARICX20200131 from '@/views/20200131SARICX';
import nCoVExam20200206 from '@/views/20200206nCoVExam';
import ZMXL20200211 from '@/views/20200211ZMXL';
import SARIQuery20200214 from '@/views/20200214SARIQuery';
import SHZLM20200224 from '@/views/20200224SHZLM';
import LHYZ20200210 from '@/views/20200210LHYZ';
import CJH20200306 from '@/views/20200306CJH';
import CDWM20200317 from '@/views/20200317CDWM';
import YLLH20200324 from '@/views/20200324YLLH';
import YZCM20200402 from '@/views/20200402YZCM';

import FDYW20200331 from '@/views/20200331FDYW';
import ZBBYQ from '@/views/20200303ZBBYQ';
import GKBTW20200330 from '@/views/20200330GKBTW';
import ZWXQD20200421 from '@/views/20200421ZWXQD';
import GYGG20200401 from '@/views/20200401GYGG';
import JJRW20200409 from '@/views/20200409JJRW';
import CSJX20200424 from '@/views/20200424CSJX';
import YHQ20200427 from '@/views/20200427YHQ';
import DGRWQ20201123 from '@/views/20201123DGRWQ';
import LHYWD202133 from '@/views/202133LHYWD';
import vglh20210305 from '@/views/20210305vglh';
import Xfz20210311 from '@/views/20210311Xfz';
import Zscqr20210401 from '@/views/20210401Zscqr';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: () => import('@/views/HelloWorld.vue'),
    },
    {
      path: '/news',
      name: 'News',
      component: () => import('@/views/News.vue'),
    },
    {
      path: '/apidemo',
      name: 'ApiDemo',
      component: () => import('@/views/demo/ApiDemo.vue'),
    },
    {
      path: '/weChatLogin',
      name: 'weChatLogin',
      component: () => import('@/views/WeChatLoginPage.vue'),
    },
    {
      path: '/20200118JTYM/First',
      component: () => import('@/views/20200118JTYM/First.vue'),
      name: '20200118JTYMFirst',
      meta: {
        title: '九童圆梦',
      },
    },
    // 2020年会活动
    NHHD20200120,
    // 2020两会圆桌
    LHYZ20200109,
    // 2020找帮帮
    ZBB2020,
    // 2020九童圆梦
    JTYM20200118,
    // 2020重庆两会专题报道
    CQLH20200106,
    // 2020中国·重庆国际康养盛典暨康养创新项目发布会
    GJKYSD20200108,
    // 两会圆桌预览
    LHYZPre20200109,
    // 名师名著创新写作
    MSMZWriting20190121,
    // 体彩特约上游运动家短视频挑战赛
    TCTYSYYDJ20200203,
    // SARI
    SARI20200128,
    // SARI查询
    SARICX20200131,
    // nCoV答题涨姿势
    nCoVExam20200206,
    // 寻找“平凡英雄•最美力量”
    ZMXL20200211,
    // 联合义诊
    LHYZ20200210,
    // 肺炎综合查询
    SARIQuery20200214,
    // 守护者联盟
    SHZLM20200224,
    // 旅游交易会
    CJH20200306,
    // 找帮帮疫情咨询
    ZBBYQ,
    // 吃得文明公益主题征文大赛
    CDWM20200317,
    // 园林绿化知识竞赛
    YLLH20200324,
    // 疫战成名
    YZCM20200402,
    // 高考不停问
    GKBTW20200330,
    // 奋斗有我
    FDYW20200331,
    // 上游作文频道上线
    ZWXQD20200421,
    // 吃得文明公益广告创作大赛
    GYGG20200401,
    // 十大经济人物
    JJRW20200409,
    // 城市匠星
    CSJX20200424,
     // 500万优惠券来了
    YHQ20200427,
     // 打工人维权
    DGRWQ20201123,
     // 两会云问答
    LHYWD202133,
        // v观两会
    vglh20210305,
       // v观两会
    Xfz20210311,
      // 知识产权日
    Zscqr20210401,


  ],
  // 跳转后回到顶部
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0, // 离奇bug，只有当y不为0的时候，keep-alive页面在 activated 的时候才会记住滚动位置;
    };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = (router as Router & { history: any }).history.pending
    .fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
